module.exports = __webpack_public_path__ + "img/DSC_0058.5faca036.jpg";